import AxiosInterceptor from "../utils/AxiosInterceptor";
import { API_BASE } from "../utils/constants";

export const apiAuth = {
  resetPassword: (value) =>
    AxiosInterceptor().post(API_BASE + "/update-password", value),
  getAdminDetails: (value) =>
    AxiosInterceptor().get(API_BASE + "/getAdminDetails", value),
  updateAdminProfile: (value) =>
    AxiosInterceptor().post(API_BASE + "/editProfile", value),
  changePassword: (value) =>
    AxiosInterceptor().post(API_BASE + "/changePassword", value),
  getSetting: (value) =>
    AxiosInterceptor().get(API_BASE + "/getSetting", value),
  updateSetting: (value) =>
    AxiosInterceptor().post(API_BASE + "/updateSetting", value),
  getAllCountry: (value) =>
    AxiosInterceptor().get(API_BASE + "/getAllCountries", value),
  updateCountry: (value) =>
    AxiosInterceptor().post(API_BASE + "/updateCountries", value),
  changeStatus: (value) =>
    AxiosInterceptor().post(API_BASE + "/changeStatusLanguage", value),
  getAll: (value) =>
    AxiosInterceptor().post(API_BASE + "/getAllLanguages", value),
};

export const userServices = {
  getUser: (values) => AxiosInterceptor().post(`/getAllUser`, values),
  getById: (values) => AxiosInterceptor().get(`/getUser/${values?.id}`),
  add: (values) => AxiosInterceptor().post(`/addUser`, values),
  edit: (value) => AxiosInterceptor().post(`/updateUser`, value),
  deleteUser: (value) => AxiosInterceptor().post(`/deleteUser`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/changeUserStatus`, value),
  approveRejectWithdrawal: (value) =>
    AxiosInterceptor().post(`/approveRejectWithdrawal`, value),
  getDeletionRequests: (values) =>
    AxiosInterceptor().post(`/getDeletionRequests`, values),
  updateDeletionRequest: (value) =>
    AxiosInterceptor().post(`/updateDeletionRequest`, value),
};

export const adminServices = {
  getAdmins: (values) => AxiosInterceptor().post(`/getAllAdmins`, values),
  getById: (values) => AxiosInterceptor().get(`/getAdmin/${values?.id}`),
  add: (values) => AxiosInterceptor().post(`/addAdmin`, values),
  edit: (value) => AxiosInterceptor().post(`/updateAdmin/${value?.id}`, value),
  deleteAdmin: (value) => AxiosInterceptor().delete(`/deleteAdmin/${value?.id}`),
  changeStatus: (value) => AxiosInterceptor().post(`/changeAdminStatus`, value),
  changePassword: (value) => AxiosInterceptor().post(`/changeAdminPassword/${value?.id}`, value),
};

export const playerServices = {
  getAllPlayers: (values) => AxiosInterceptor().post(`/getPlayers`, values),
  updatePlayer: (values) => AxiosInterceptor().post(`/updateAllPlayers`, values),
  getPlayerTeamPositions: (values) =>
    AxiosInterceptor().post(`/getPlayerTeamPositions`, values),
  updatePlayerTeamPositions: (values) =>
    AxiosInterceptor().post(`/updatePlayerTeamPositions`, values),
};


export const LeagueManagementService = {
  getBids: (values) => AxiosInterceptor().post(`/getAllLeagues`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneLeague/${values.id}`),
  deleteBid: (value) => AxiosInterceptor().post(`/deleteLeague`, value),
  changeStatus: (value) =>
    AxiosInterceptor().post(`/changeLeagueStatus`, value),
  getCountry: () => AxiosInterceptor().get("/countries"),
};

export const contestServices = {
  // contestServices
  add: (values) => AxiosInterceptor().post(`/addContest`, values),
  edit: (values) => AxiosInterceptor().post(`/updateContest`, values),
  getAllLeagues: (values) => AxiosInterceptor().post(`/getAllLeagues`, values),
  getContest: (values) => AxiosInterceptor().post(`/getAllContests`, values),
  getContestForHotContest: (values) => AxiosInterceptor().post(`/getAllContestForHotContest`, values),
  addToHotContest: (values) => AxiosInterceptor().post(`/addToHotContest`, values),
  removeFromHotContest: (values) => AxiosInterceptor().post(`/removeFromHotContest`, values),
  saveHotContestOrder: (values) => AxiosInterceptor().post(`/saveHotContestOrder`, values),
  getAllHotContests: (values) => AxiosInterceptor().post(`/getAllHotContests`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneContest/${values.id}`),
  deleteContest: (value) => AxiosInterceptor().post(`/deleteContest`, value),
  changeStatus: (value) =>
    AxiosInterceptor().post(`/changeContestStatus`, value),
  getLeaderboard: (value) => AxiosInterceptor().post(`/getLeaderboard`, value),
  getAllFantasyGames: (value) =>
    AxiosInterceptor().post(`/getAllFantasyGames`, value),
  countMatchTimeWise: (values) =>
    AxiosInterceptor().post(`/countMatchTimeWise`, values),
  getMatchesByDate: (values) =>
    AxiosInterceptor().post(`/getMatchesByDate`, values),
  getFantasyGameTeamById: (values) =>
    AxiosInterceptor().get(`/getFantasyGameTeamById/${values.id}`),
};

export const emailServices = {
  // Email
  getEmail: (values) => AxiosInterceptor().post(`/getAllTemplate`, values),
  addEmail: (value) => AxiosInterceptor().post(`/addTemplate`, value),
  getByIdEmail: (values) =>
    AxiosInterceptor().get(`/getOneTemplate/${values.id}`),
  editEmail: (value) => AxiosInterceptor().post(`/updateTemplate`, value),
  deleteEmail: (value) => AxiosInterceptor().post(`/deleteTemplate`, value),
  changeStatusEmail: (value) => AxiosInterceptor().post("/changeStatus", value),
};

export const apiCategory = {
  add: (value) => AxiosInterceptor().post(`/category/category`, value),
  edit: (value) => AxiosInterceptor().post(`/category/update-category`, value),
  delete: (value) =>
    AxiosInterceptor().post(`/category/delete-category`, value),
  getAll: (values) => AxiosInterceptor().post(`/category/categories`, values),
  getById: (values) =>
    AxiosInterceptor().post(`/category/single-category`, values),
  changeStatus: (value) =>
    AxiosInterceptor().post("/category/update-status", value),
  getAllSubCategory: (values) =>
    AxiosInterceptor().post(`/subcategory/getAllSubcategories`, values),
  addSubCategory: (value) =>
    AxiosInterceptor().post(`/subcategory/add-subcategory`, value),
  editSubCategory: (value) =>
    AxiosInterceptor().post(`/subcategory/edit-subcategory`, value),
  deleteSubCategory: (value) =>
    AxiosInterceptor().post(`/subcategory/delete-subcategory`, value),
  getByIdSubCategory: (values) =>
    AxiosInterceptor().post(`/subcategory/get-by-id`, values),
  changeStatusSubCategory: (value) =>
    AxiosInterceptor().post("/subcategory/update-status", value),
};

export const apiCms = {
  add: (value) => AxiosInterceptor().post(`/create`, value),
  edit: (value) => AxiosInterceptor().post(`/updateContent`, value),
  delete: (value) => AxiosInterceptor().post(`/delete`, value),
  getAll: (values) => AxiosInterceptor().post(`/getAllContent`, values),
  getById: (values) =>
    AxiosInterceptor().get(`/getOneContent/${values.id}`, values),
  changeStatus: (value) => AxiosInterceptor().post("/update-status", value),

  // Faq
  getFaq: (values) => AxiosInterceptor().post(`/getAllFaqs`, values),
  addFaq: (value) => AxiosInterceptor().post(`/addFaqs`, value),
  getByIdFaq: (values) => AxiosInterceptor().get(`/getOneFaq/${values.id}`),
  editFaq: (value) => AxiosInterceptor().post(`/updateFaqs`, value),
  deleteFaq: (value) => AxiosInterceptor().post(`/deleteFaq`, value),
  changeStatusFaq: (value) =>
    AxiosInterceptor().post("/changeStatusFaq", value),
};

export const apiHowToplay = {
  getAll: (values) => AxiosInterceptor().post(`/getAllHowToPlays`, values),
  add: (value) => AxiosInterceptor().post(`/addHowToPlay`, value),
  getById: (values) => AxiosInterceptor().get(`/getOneHowToPlay/${values.id}`),
  edit: (value) => AxiosInterceptor().post(`/updateHowToPlays`, value),
  delete: (value) => AxiosInterceptor().post(`/deleteHowToPlay`, value),
  changeStatus: (value) => AxiosInterceptor().post("/changeStatusHTP", value),
};

export const apiJackpotService = {
  getAll: (values) => AxiosInterceptor().post(`/getAllJackpot`, values),
  add: (value) => AxiosInterceptor().post(`/addJackpot`, value),
  getById: (values) => AxiosInterceptor().get(`/getOneJackpot/${values.id}`),
  edit: (value) => AxiosInterceptor().post(`/updateJackpot`, value),
  delete: (value) => AxiosInterceptor().post(`/deleteJackpot`, value),
  changeStatus: (value) => AxiosInterceptor().post("/changeStatusHTP", value),
  selectWinners: (value) => AxiosInterceptor().post("/selectWinners", value),
  getAllContestUsers: (value) =>
    AxiosInterceptor().post("/getAllContestUsers", value),
  getContest: () => AxiosInterceptor().get("/getContest"),
  getUsers: (value) => AxiosInterceptor().post("/getusers", value),
};

export const teamManagementApi = {
  getAll: (values) => AxiosInterceptor().post(`/getAllPlayers`, values),
  getById: (values) => AxiosInterceptor().get(`/getOnePlayers/${values.id}`),
  edit: (value) => AxiosInterceptor().post(`/updatePlayers`, value),
  getPlayer: (value) => AxiosInterceptor().post(`/getAllTeams`, value),
};

export const DashboardApi = {
  getAll: () => AxiosInterceptor().get("/getDashboardReports"),
  getRevenue: () => AxiosInterceptor().get("/getRevenueAnalytics"),
};

export const gameManagementApi = {
  getById: (value) => AxiosInterceptor().get(`/getOneGame/${value.id}`),
  getAllGames: (value) => AxiosInterceptor().post(`/getAllGames`, value),
  edit: (value) => AxiosInterceptor().post(`/updateGame`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/changeGameStatus`, value),
};

export const walletServices = {
  getUser: (values) => AxiosInterceptor().post(`/getAllUser`, values),
  getByIdTransation: (values) =>
    AxiosInterceptor().get(`/get-trxn/${values?.id}`),
  add: (values) => AxiosInterceptor().post(`/addUser`, values),
  edit: (value) => AxiosInterceptor().post(`/updateUser`, value),
  deleteUser: (value) => AxiosInterceptor().post(`/deleteUser`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/changeUserStatus`, value),
  getusertransaction: (values) =>
    AxiosInterceptor().post(`/user-transaction`, values),
  getAllWithdrawalRequest: (values) =>
    AxiosInterceptor().post(`/all-withdrawl-pending-request`, values),
  withdrawlRequest: (values) =>
    AxiosInterceptor().post(`/withdrawl-request`, values),
  updateWallet: (value) => AxiosInterceptor().post(`/updateUserWallet`, value),
};

export const gamePointManagementApi = {
  getAll: (values) => AxiosInterceptor().post(`/getAllFantasyPoints`, values),
  getById: (values) =>
    AxiosInterceptor().get(`/getOneFantasyPoints/${values?.id}`),
  add: (values) => AxiosInterceptor().post(`/addFantasyPoints`, values),
  edit: (value) => AxiosInterceptor().post(`/updateFantasyPoints`, value),
  deleteUser: (value) => AxiosInterceptor().post(`/deleteFantasyPoints`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/changeUserStatus`, value),
  getusertransaction: (values) =>
    AxiosInterceptor().post(`/user-transaction`, values),
  pointStatus: (values) =>
    AxiosInterceptor().post(`/changeScoringStatus`, values),
};

export const RevenueApi = {
  getTotalRevenue: (value) => AxiosInterceptor().post("/totalRevenue", value),
};

export const ReferralManagementApi = {
  getAll: (values) =>
    AxiosInterceptor().post(`/getAllUsersWithReferral`, values),
  getById: (values) =>
    AxiosInterceptor().get(`/getUserReferralDetails/${values?.id}`),
};

export const notificationManagementApi = {
  getAllNotification: (values) =>
    AxiosInterceptor().post(`/notification/getAllTemplate`, values),
  getByIdNotification: (values) =>
    AxiosInterceptor().get(`/notification/getOneTemplate/${values.id}`),
  editNotification: (value) =>
    AxiosInterceptor().post(`/notification/updateTemplate`, value),
  changeStatusNotificaton: (value) =>
    AxiosInterceptor().post("/notification/changeStatus", value),
  addNotification: (value) =>
    AxiosInterceptor().post(`/notification/addTemplate`, value),
  deleteNotification: (value) =>
    AxiosInterceptor().post(`/notification/deleteTemplate`, value),
};

export const friendModalListApi = {
  getUserFriendList: (values) =>
    AxiosInterceptor().post(`/getUserFriendList`, values),
};

export const AboutUsApi = {
  update: (value) => AxiosInterceptor().post(`/createOrUpdateAboutUs`, value),
  getById: (values) => AxiosInterceptor().get(`/getAboutUs`, values),
};

export const ChatApi = {
  getChatHistory: (value) =>
    AxiosInterceptor().post(`/getChatHistoryByUserId`, value),
  getChatPersonsList: (values) =>
    AxiosInterceptor().post(`/getChatPersonsList`, values),
  deleteMessage: (values) =>
    AxiosInterceptor().post(`/deleteMessageById/${values?.id}`),
  deleteChat: (value) =>
    AxiosInterceptor().post(`/deleteChatHistoryWithUser`, value),
};

export const boostersServices = {
  getAllBooster: (values) => AxiosInterceptor().post(`/getAllBoosters`, values),
  getOneBoosters: (values) =>
    AxiosInterceptor().get(`/getOneBoosters/${values.id}`),
  updateBoosters: (value) => AxiosInterceptor().post(`/updateBoosters`, value),
  deleteEmail: (value) => AxiosInterceptor().post(`/deleteTemplate`, value),
  changeBoosterStatus: (value) =>
    AxiosInterceptor().post("/changeBoosterStatus", value),
};

export const gemPackagesServices = {
  getAllGemPackages: (values) => AxiosInterceptor().post(`/getAllGemPackages`, values),
  updateGemPackages: (value) => AxiosInterceptor().post(`/updateGemPackage`, value),
  deleteGemPackages: (value) => AxiosInterceptor().post(`/deleteGemPackage`, value),
  addGemPackage: (value) => AxiosInterceptor().post("/addGemPackage", value),
  getGemPackage: (value) => AxiosInterceptor().get(`/getGemPackage/${value.id}`),
};

export const ResponsibleGamblingApi = {
  getResponsibleGamblingById: (values) =>
    AxiosInterceptor().get(`/getResponsibleGamblingById`, values),
  update: (value) =>
    AxiosInterceptor().post(`/updateResponsibleGambling`, value),
};

export const getLeagueRoundsWithMatches = {
  getLeagueRounds: (values) =>
    AxiosInterceptor().post(`/getLeagueRoundsWithMatches`, values),
};

export const apiCurrency = {
  getAll: (values) => AxiosInterceptor().post(`/getAllCurrencies`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneCurrency/${values.id}`),
  add: (value) => AxiosInterceptor().post(`/addCurrency`, value),
  edit: (value) => AxiosInterceptor().post(`/updateCurrency`, value),
  delete: (value) => AxiosInterceptor().post(`/deleteCurrency`, value),
  changeStatus: (value) => AxiosInterceptor().post("/changeStatusCurrency", value),
  updateMultiple: (values) => AxiosInterceptor().post(`/updateMultipleCurrencies`, values),
  getCountriesWithCurrency: (data) => AxiosInterceptor().get(`/getCountriesWithCurrency`, data),
  getExchangeRates: (data) => AxiosInterceptor().get(`/getExchangeRates`, data),
};

export const apiCoinPackages = {
  getAll: (values) => AxiosInterceptor().post(`/getAllCoinPackages`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneCoinPackage/${values.id}`),
  add: (value) => AxiosInterceptor().post(`/addCoinPackage`, value),
  edit: (value) => AxiosInterceptor().post(`/updateCoinPackage`, value),
  delete: (value) => AxiosInterceptor().post(`/deleteCoinPackage`, value),
  changeStatus: (value) => AxiosInterceptor().post("/changeStatusCoinPackage", value),
};

export const sportNewsApi = {
  getAllSportNews: (values) =>
    AxiosInterceptor().post(`/getAllSportNews`, values),
  getOneSportNews: (id) => AxiosInterceptor().get(`/getOneSportNews/${id}`),
  addSportNews: (formData) =>
    AxiosInterceptor().post(`/addSportNews`, formData),
  updateSportNews: (formData, id) =>
    AxiosInterceptor().post(`/updateSportNews/${id}`, formData),
  deleteSportNews: (id) => AxiosInterceptor().post(`/deleteSportNews/${id}`),
  changeStatus: (value, id) =>
    AxiosInterceptor().post(`/changeSportNewsStatus/${id}`, value),
};

export const sportNewsCategoryApi = {
  getAllSportNewsCategories: (values) =>
    AxiosInterceptor().post(`/getAllSportNewsCategories`, values),
  getOneSportNewsCategory: (id) =>
    AxiosInterceptor().get(`/getOneSportNewsCategory/${id}`),
  addSportNewsCategory: (value) =>
    AxiosInterceptor().post(`/addSportNewsCategory`, value),
  updateSportNewsCategory: (value) =>
    AxiosInterceptor().post(`/updateSportNewsCategory`, value),
  changeStatus: (value) =>
    AxiosInterceptor().post(`/changeStatusSportNewsCategory`, value),
  deleteSportNewsCategory: (id) =>
    AxiosInterceptor().get(`/deleteSportNewsCategory/${id}`),
};

/** Upload an image for rich-text editors; returns a usable image URL string. */
export const mediaUploadApi = {
  uploadImage: (file, imagePath = "news") => {
    const formData = new FormData();
    // imagePath must come before the file so multer can read it during storage
    formData.append("imagePath", imagePath);
    formData.append("image", file);
    return AxiosInterceptor().post(`/uploadEditorImage`, formData);
  },
};
